document.addEventListener('DOMContentLoaded', function() {
    var navItems = document.querySelectorAll('.nav-item.dropdown');

    navItems.forEach(function(everyItem) {
        everyItem.addEventListener('mouseenter', function(e) {
            var dropdown = this.querySelector('.dropdown-menu');
            if (dropdown) {
                dropdown.classList.add('show');
                this.classList.add('show');
            }
        });

        everyItem.addEventListener('mouseleave', function(e) {
            var dropdown = this.querySelector('.dropdown-menu');
            if (dropdown) {
                dropdown.classList.remove('show');
                this.classList.remove('show');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('header');
    const headerBackground = document.querySelector('.site-header__background');

    header.addEventListener('mouseenter', function() {
        const headerHeight = header.offsetHeight + 'px'; // Get the current height of the header
        headerBackground.style.setProperty('height', headerHeight); // Set the height to match the header height
        header.classList.add('hovered'); // Add 'hovered' class to the header
    });

    header.addEventListener('mouseleave', function() {
        headerBackground.style.setProperty('height', '0px'); // Reset the height when not hovered
        header.classList.remove('hovered'); // Remove 'hovered' class from the header
    });
});



